
import { ChangeDetectionStrategy, Component, SimpleChanges } from '@angular/core';
import { CustomizerColorsAutoUpdateComponent, CustomizerComponentHeaderComponent } from '@app/customizer/components';
import { PreciousMetalInfoComponent } from '@app/customizer/components/precious-metal-info/precious-metal-info.component';
import { ComponentVariantFromApiModel } from '@models/api-models/component-variant-fromapi';
import { ComponentVariantModel } from '@models/component-variant';
import { ComponentVariantChangeModel } from '@models/component-variant-change';
import { VariantColorModel } from '@models/variant-color';
import { BrandModeService } from '@services/brandmode.service';
import { ConfigurationService } from '@services/configuration.service';
import { DataApiService } from '@services/data-api.service';
import { EventsService } from '@services/events.service';
import { BaseCustomizerComponent } from '@shared/base-customizer-component';

@Component({
    selector: 'upper-rim-color-menu',
    template: `
      <customizer-component-header [menu]="menu" (updateCollapsedOnComponent)="updateCollapsed($event)">
        @if (selectableVariants.length) {
          <customizer-colors-auto-update
            [selected]="getSelectedVariant.VariantColor"
            [selectedColorGroup]="currentColorGroup"
            [variants]="selectableVariants"
            [editMode]="state === customizerStateEnum.EDITORDER"
            [matchableColors]="matchableColors"
            [useColorGroup]="menu.contentGrouping"
            (colorMatchChange)="matchColors($event)"
            (selectedColorGroupChange)="onSelectGroup($event)"
            (selectedColorChange)="onSelect($event)"
            [(scrollPosition)]="menu.menuDetails.scrollPosition"
            [extendedInformation]="extendedInformation"
            [extendedInformationTable]="false"
            [variantOrModelIsNew]="variantOrModelIsNew"
            [matchColor]="menu.matchColor"
            >
          </customizer-colors-auto-update>
        }
      </customizer-component-header>
      <precious-metal-info></precious-metal-info>
      `,
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [CustomizerComponentHeaderComponent, PreciousMetalInfoComponent, CustomizerComponentHeaderComponent, CustomizerColorsAutoUpdateComponent]
})
export class UpperRimColorComponent extends BaseCustomizerComponent {

	public selectableVariants: Array<ComponentVariantFromApiModel> = [];
	public extendedInformation: boolean = false;

	constructor(
		public override events: EventsService,
		public apiService: DataApiService,
		public override configurationService: ConfigurationService,

		private brandmodeService: BrandModeService
	) {
		super(events, apiService, configurationService);
		this.extendedInformation = this.brandmodeService.isPrecious;
	}

	async initData() {
		this.events.showLoader(true);

		this.selectableVariants = await this.fetchData() ?? [];

		this.events.showLoader(false);
	}

	onChanges(changes: SimpleChanges) {
	}

	async fetchData(): Promise<Array<ComponentVariantFromApiModel> | undefined> {
		const variant = this.getSelectedVariant;
		variant.VariantColorViewed = true;

		const apidata = await this.configurationService.getVariants(this.configuration?.ModelConfigurationUuid, this.modelGroup, undefined, variant.Uuid, variant.VariantSize?.Uuid);
		await this.RunDisablingSystem(apidata);
		return apidata;
	}

	onSelect(color: VariantColorModel) {
		this.events.showLoader(true);

		const newVariant = Object.assign(new ComponentVariantModel(this.getSelectedVariant.Discontinued, this.getSelectedVariant.New), this.getSelectedVariant);
		const oldVariant = Object.assign(new ComponentVariantModel(this.getSelectedVariant.Discontinued, this.getSelectedVariant.New), this.getSelectedVariant);
		newVariant.VariantColor = color;
		this.updateVariant(new ComponentVariantChangeModel(oldVariant, newVariant, null));
	}

}
